module.exports = __webpack_public_path__ + "img/map_menu.0d1791a9.svg";